import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalConnection() {
  return <section className="py-16 md:py-24 bg-warm-beige" data-id="element-64">
      <div className="max-w-4xl mx-auto px-4" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-66">
          <p className="text-sm md:text-base font-bold tracking-[0.2em] text-warm-brown uppercase mb-5" data-id="element-67">
            Porque hay regalos que no se olvidan
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-deep-brown leading-tight" data-id="element-68">
            No es un muñeco. <br className="hidden md:block" data-id="element-69" />
            Es <span className="text-warm-brown italic" data-id="element-70">tu mascota</span>,
            tejida con amor.
          </h2>

          <div className="w-24 h-1 bg-soft-rose mx-auto mt-8 rounded-full" data-id="element-71" />
        </motion.div>
      </div>
    </section>;
}